module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/bg-balloon-d3e393727ea3c8296822d52fbbd495bd.svg";